import { WithdrawPhase, WithdrawState } from "../../payments/PaymentsReducer";
import { t } from "../../i18n";
import ConfirmWithdraw from "../withdraw/ConfirmWithdraw";
import WithdrawResponseView from "../withdraw/WithdrawResponseView";
import CryptoDetails from "../withdraw/CryptoDetails";
import CloseIcon from "../../utils/closeIcon";

interface Props {
  withdraw?: WithdrawState;
  handleClickOk?: () => void;
}

function CryptoChillWithdraw({ withdraw, handleClickOk }: Props) {
  const withdrawPhase = withdraw && withdraw.phase;

  return (
    <div className="withdraw-title">
      {(withdrawPhase === WithdrawPhase.CHOOSE_ADDRESS || withdrawPhase === WithdrawPhase.CHOOSE_AMOUNT) && <CryptoDetails />}
      {withdrawPhase === WithdrawPhase.CONFIRM_WITHDRAW && <ConfirmWithdraw />}
      {withdrawPhase === WithdrawPhase.WITHDRAW_RESPONSE && withdraw && handleClickOk && <WithdrawResponseView onClick={handleClickOk} />}
      {withdrawPhase === WithdrawPhase.REQUEST_DENIED && (
        <div className="requestDenied">
          <CloseIcon className={`invalid-icon`} animate={true} />
          <span>{t(`withdraw.requestDenied-reason.${withdraw?.withdrawResponse?.result ?? "ERROR"}`)}</span>
        </div>
      )}
      {withdrawPhase === WithdrawPhase.ERROR && (
        <div className="requestDenied">
          <CloseIcon className={`invalid-icon`} animate={true} />
          <span>{t("withdraw.withdrawError")}</span>
        </div>
      )}
    </div>
  );
}

export default CryptoChillWithdraw;
